module.exports = "<span data-ng-message=required>*Threat impact is required.</span>";